"use strict";
/**
 * @module Features.Security
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Permissions that are applied globally
 *
 * This enum maps the values of {@link GlobalPermission} to internal protocol codes
 */
var GlobalPermissionCode;
(function (GlobalPermissionCode) {
    GlobalPermissionCode[GlobalPermissionCode["AUTHENTICATE"] = 0] = "AUTHENTICATE";
    GlobalPermissionCode[GlobalPermissionCode["VIEW_SESSION"] = 1] = "VIEW_SESSION";
    GlobalPermissionCode[GlobalPermissionCode["MODIFY_SESSION"] = 2] = "MODIFY_SESSION";
    GlobalPermissionCode[GlobalPermissionCode["REGISTER_HANDLER"] = 3] = "REGISTER_HANDLER";
    GlobalPermissionCode[GlobalPermissionCode["VIEW_SERVER"] = 4] = "VIEW_SERVER";
    GlobalPermissionCode[GlobalPermissionCode["CONTROL_SERVER"] = 5] = "CONTROL_SERVER";
    GlobalPermissionCode[GlobalPermissionCode["VIEW_SECURITY"] = 6] = "VIEW_SECURITY";
    GlobalPermissionCode[GlobalPermissionCode["MODIFY_SECURITY"] = 7] = "MODIFY_SECURITY";
    GlobalPermissionCode[GlobalPermissionCode["UNKNOWN_GLOBAL_PERMISSION"] = 8] = "UNKNOWN_GLOBAL_PERMISSION";
    GlobalPermissionCode[GlobalPermissionCode["READ_TOPIC_VIEWS"] = 9] = "READ_TOPIC_VIEWS";
    GlobalPermissionCode[GlobalPermissionCode["MODIFY_TOPIC_VIEWS"] = 10] = "MODIFY_TOPIC_VIEWS";
})(GlobalPermissionCode = exports.GlobalPermissionCode || (exports.GlobalPermissionCode = {}));
/**
 * Permissions that are applied on a path
 *
 * This enum maps the values of {@link PathPermission} to internal protocol codes
 */
var PathPermissionCode;
(function (PathPermissionCode) {
    PathPermissionCode[PathPermissionCode["READ_TOPIC"] = 0] = "READ_TOPIC";
    PathPermissionCode[PathPermissionCode["UPDATE_TOPIC"] = 1] = "UPDATE_TOPIC";
    PathPermissionCode[PathPermissionCode["MODIFY_TOPIC"] = 2] = "MODIFY_TOPIC";
    PathPermissionCode[PathPermissionCode["SEND_TO_MESSAGE_HANDLER"] = 3] = "SEND_TO_MESSAGE_HANDLER";
    PathPermissionCode[PathPermissionCode["SEND_TO_SESSION"] = 4] = "SEND_TO_SESSION";
    PathPermissionCode[PathPermissionCode["SELECT_TOPIC"] = 5] = "SELECT_TOPIC";
    PathPermissionCode[PathPermissionCode["QUERY_OBSOLETE_TIME_SERIES_EVENTS"] = 6] = "QUERY_OBSOLETE_TIME_SERIES_EVENTS";
    PathPermissionCode[PathPermissionCode["EDIT_TIME_SERIES_EVENTS"] = 7] = "EDIT_TIME_SERIES_EVENTS";
    PathPermissionCode[PathPermissionCode["EDIT_OWN_TIME_SERIES_EVENTS"] = 8] = "EDIT_OWN_TIME_SERIES_EVENTS";
    PathPermissionCode[PathPermissionCode["ACQUIRE_LOCK"] = 9] = "ACQUIRE_LOCK";
    PathPermissionCode[PathPermissionCode["UNKNOWN_TOPIC_PERMISSION"] = 10] = "UNKNOWN_TOPIC_PERMISSION";
    PathPermissionCode[PathPermissionCode["UNKNOWN_PATH_PERMISSION"] = 10] = "UNKNOWN_PATH_PERMISSION";
    PathPermissionCode[PathPermissionCode["EXPOSE_BRANCH"] = 11] = "EXPOSE_BRANCH";
})(PathPermissionCode = exports.PathPermissionCode || (exports.PathPermissionCode = {}));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/security/permission.js
// module id = 377
// module chunks = 1